import { Category } from '../py-generated/datalouder/stock/types';
import { GetStockTagsResponse } from '../py-generated/datalouder/tag/types';
import { apiv2Url } from './config';
import { getPromise, postPromise } from './utils';

const getStockTags = async (
  forceRefresh?: boolean,
  abortSignal?: AbortSignal
): Promise<GetStockTagsResponse> => {
  const response = await getPromise<
    Record<string, unknown>,
    GetStockTagsResponse
  >(`${apiv2Url}/tags`, { forceRefresh }, undefined, abortSignal);

  // remove the serial number from AWS responses
  for (const tagId in response.stocksByTag) {
    response.stocksByTag[tagId] = response.stocksByTag[tagId].map(
      fullStockId => {
        const [category, ticker] = fullStockId.split('#');
        return category + '#' + ticker;
      }
    );
  }

  return response;
};

const addStockTag = async (
  tagId: string,
  category: Category,
  ticker: string
): Promise<void> => {
  await postPromise<Record<string, unknown>, unknown>(
    `${apiv2Url}/tags/admin/manage`,
    { action: 'add', tagId, category, ticker }
  );
};

const removeStockTag = async (
  tagId: string,
  category: Category,
  ticker: string
): Promise<void> => {
  await postPromise<Record<string, unknown>, unknown>(
    `${apiv2Url}/tags/admin/manage`,
    { action: 'remove', tagId, category, ticker }
  );
};

const tagServices = {
  getStockTags,
  addStockTag,
  removeStockTag,
};

export default tagServices;
